import NotificationCenterScreen from './NotificationCenterScreen'

export default function NotificationScreen() {
  return <NotificationCenterScreen />
}
